/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'

const SidebarMenuMain = () => {
  const intl = useIntl()

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Menu</span>
        </div>
      </div>
      <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        // title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        title='Tableau de bord'
        fontIcon='bi-app-indicator'
      />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Management</span>
        </div>
      </div>

      <SidebarMenuItem to='/client' icon='people' title='Clients' fontIcon='bi-app-indicator' />

      {/* <SidebarMenuItem
        to='/suppliers'
        icon='dropbox'
        title='Fournisseurs'
        fontIcon='bi-app-indicator'
      /> */}

      <SidebarMenuItem
        to='/service'
        icon='element-7'
        title='Services'
        fontIcon='bi-app-indicator'
      />
      {/* <SidebarMenuItem
        to='/store'
        icon='shop'
        title='Magasins'
        fontIcon='bi-app-indicator'
      /> */}
      {/* <SidebarMenuItem to='/service' icon='element-9' title='Service' fontIcon='bi-app-indicator' /> */}

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Documents</span>
        </div>
      </div>

      <SidebarMenuItemWithSub to='/sale' title='Vente' fontIcon='bi-archive' icon='handcart'>
        <SidebarMenuItem to='/sale/estimate' title='Devis' hasBullet={true} />
        {/* <SidebarMenuItem to='/sale/order' title='Commande' hasBullet={true} /> */}
        {/* <SidebarMenuItem to='/sale/delivery-note' title='Livraison' hasBullet={true} /> */}
        <SidebarMenuItem to='/sale/invoice' title='Facture' hasBullet={true} />
        <SidebarMenuItem to='/sale/attachedInvoice' title='Avoir' hasBullet={true} />
        <SidebarMenuItem to='/documents/signed' title='Factures signées' hasBullet={true} />
      </SidebarMenuItemWithSub>

      {/* <SidebarMenuItemWithSub
        to='/purchase'
        title='Achat'
        fontIcon='bi-archive'
        icon='two-credit-cart'
      >
        <SidebarMenuItem
          to='/purchase/supplier-order'
          title='Commande Fournisseur'
          hasBullet={true}
        />
        <SidebarMenuItem
          to='/purchase/supplier-deliverynote'
          title='Bon De Reception'
          hasBullet={true}
        />
        <SidebarMenuItem
          to='/purchase/supplier-invoice'
          title='Facture Fournisseur'
          hasBullet={true}
        />
        <SidebarMenuItem to='/purchase/attachedInvoice' title='Facture avoir ' hasBullet={true} />
      </SidebarMenuItemWithSub> */}

      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Stock</span>
        </div>
      </div>

      <SidebarMenuItem
        to='/sale/caisse/order'
        icon='dropbox'
        title='Caisse Order'
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItem
        to='/stock/input'
        icon='left-square'
        title='Entrée'
        fontIcon='bi-app-indicator'
      />  <SidebarMenuItem
        to='/stock/output'
        icon='right-square'
        title='Sortie'
        fontIcon='bi-app-indicator'
      />   */}
      {/* <SidebarMenuItem
        to='/stock/transfer'
        icon='bi bi-arrow-left-right'
        title=' Transfert'
        fontIcon='bi-app-indicator'
      /> */}
      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>réglement</span>
        </div>
      </div>

      <SidebarMenuItem to='/reglement' icon='bill' title='Réglements' fontIcon='bi-app-indicator' /> */}

      {/* 
   <SidebarMenuItem
        to='/sale/caisse/create'
        icon='dropbox'
        title='Caisse'
        fontIcon='bi-app-indicator'
      />

      <SidebarMenuItemWithSub
        to='/accounting'
        title='Comptabilité'
        fontIcon='bi-archive'
        icon='financial-schedule'
      >
        <SidebarMenuItem
          to='/accounting/project-management'
          title='Gestion des marché'
          hasBullet={true}
        />

        <SidebarMenuItem
          to='/accounting/cash-management'
          title='Gestion de la Trésorerie'
          hasBullet={true}
        />
        <SidebarMenuItem to='/accounting/bank' title='Compte Bancaire' hasBullet={true} />
      </SidebarMenuItemWithSub>
      
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Stock</span>
        </div>
      </div>

      <SidebarMenuItem
        to='/sale/caisse/create'
        icon='dropbox'
        title='Caisse'
        fontIcon='bi-app-indicator'
      />

      <SidebarMenuItemWithSub
        to='/accounting'
        title='Comptabilité'
        fontIcon='bi-archive'
        icon='financial-schedule'
      >
        <SidebarMenuItem
          to='/accounting/project-management'
          title='Gestion des marché'
          hasBullet={true}
        />

        <SidebarMenuItem
          to='/accounting/cash-management'
          title='Gestion de la Trésorerie'
          hasBullet={true}
        />
        <SidebarMenuItem to='/accounting/bank' title='Compte Bancaire' hasBullet={true} />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub to='/stock' title='Stock' fontIcon='bi-bucket' icon='home'>
        <SidebarMenuItem to='/stock/management' title='Gestion de Stock' hasBullet={true} />
        <SidebarMenuItem to='/documents/inventory' title='Invetaire' hasBullet={true} />
      </SidebarMenuItemWithSub> */}

      {/* --------------- */}

      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
        </div>
      </div>

      <SidebarMenuItemWithSub to='/sales' title='Pages' fontIcon='bi-archive' icon='element-plus'>
        <SidebarMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <SidebarMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <SidebarMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <SidebarMenuItem
            to='/crafted/pages/profile/campaigns'
            title='Campaigns'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/documents'
            title='Documents'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <SidebarMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <SidebarMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </SidebarMenuItemWithSub>
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to='/crafted/accounts'
        title='Accounts'
        icon='profile-circle'
        fontIcon='bi-person'
      >
        <SidebarMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <SidebarMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub to='/error' title='Errors' fontIcon='bi-sticky' icon='cross-circle'>
        <SidebarMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <SidebarMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/widgets'
        title='Widgets'
        icon='element-7'
        fontIcon='bi-layers'
      >
        <SidebarMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to='/apps/chat'
        title='Chat'
        fontIcon='bi-chat-left'
        icon='message-text-2'
      >
        <SidebarMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem
        to='/apps/user-management/users'
        icon='abstract-28'
        title='User management'
        fontIcon='bi-layers'
      />
      <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <Icon iconName='code' className='fs-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}

export {SidebarMenuMain}
